import React from 'react';

import { Member } from '@paragon/contract-library';

import { LumberPropertySubPanel } from '../../interface/subpanels/properties/members/LumberPropertySubPanel';
import { SceneMenuReplacement } from '../menus/common/SceneMenuReplacement';

interface Props {
  members: Member[];
}

export function EditMemberMenuReplacement({ members }: Props) {
  return (
    <SceneMenuReplacement id="edit-lumber" title="Edit Lumber" minWidth="400px">
      <LumberPropertySubPanel
        sx={{
          margin: 1,

          display: 'grid',
          gap: 2,
          gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',

          '& > *': {
            margin: 0,
            width: 'unset',
          },
        }}
        members={members}
        showAdvanced={false}
      />
    </SceneMenuReplacement>
  );
}
